import styled from 'styled-components';
import { SportsbookEventScoreboard } from '../../event-scoreboard';
import { EventWithMarketsAndSelections } from '../../../sportsbook-types';
import useEventMarketGroups from '../../../hooks/use-event-market-groups';
import useSportsbookRoutes from '../../../hooks/use-sportsbook-routes';
import { FC, useMemo } from 'react';
import { EventTags } from '../../../api/sbapi/sbapi-api-model';

const StyledScoreboard = styled(SportsbookEventScoreboard)`
	grid-column: 1;
`;

type Props = {
	event: EventWithMarketsAndSelections;
	onClick?: () => void;
};

const GameCardScoreboard: FC<Props> = ({ event, onClick }) => {
	const { getEventPageLink } = useSportsbookRoutes();

	const marketGroups = useEventMarketGroups(event);

	const eventPageLink = useMemo(() => {
		const firstMarketGroup = marketGroups.at(0);
		return getEventPageLink(
			event.sportId,
			event.sportName,
			event.leagueId,
			event.leagueName,
			event.id,
			event.eventName,
			firstMarketGroup ? { marketGroupId: firstMarketGroup.externalId } : undefined
		);
	}, [event, marketGroups, getEventPageLink]);

	return (
		<StyledScoreboard
			eventName={event.eventName}
			eventScore={event.eventScore}
			size="small"
			linkToEvent={eventPageLink}
			displayType={event.eventScore.inlineDisplayType}
			isLive={event.isLive}
			participants={event.participants || []}
			onClick={onClick}
			hasReversedOrder={event.tags.includes(EventTags.HAS_REVERSED_ORDER)}
		/>
	);
};

export default GameCardScoreboard;
